export const AVATAR_COLORS = [
  '#a69a90',
  '#4a403d',
  '#b44646',
  '#ffaf56',
  '#ea804c',
  '#2A9D90',
  '#E76E50',
  '#274754',
];
